import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import styled from 'styled-components';
import { CHAT_LIGHTBOX_EVENT } from './chat-lightbox-event';

export function ChatLightbox() {
  const [lightboxSrc, setLightboxSrc] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const handleOpen = (e: Event) => {
      const src = (e as CustomEvent<string>).detail;
      if (!src) return;
      setLightboxSrc(src);
      setIsOpen(true);
      // @ts-ignore
      dialogRef.current?.showModal?.();
    };

    window.addEventListener(CHAT_LIGHTBOX_EVENT, handleOpen);
    return () => window.removeEventListener(CHAT_LIGHTBOX_EVENT, handleOpen);
  }, []);

  const closeLightbox = () => setIsOpen(false);

  const handleExitComplete = () => {
    // @ts-ignore
    dialogRef.current?.close?.();
    setLightboxSrc(null);
  };

  return (
    <LightboxDialog ref={dialogRef} onClick={closeLightbox}>
      <AnimatePresence onExitComplete={handleExitComplete}>
        {isOpen && (
          <LightboxCentered>
            <LightboxContent
              as={motion.div}
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ duration: 0.25, ease: `easeOut` }}
              onClick={(e) => e.stopPropagation()}
            >
              <LightboxImage src={lightboxSrc} alt="" />
              <CloseButton onClick={closeLightbox}>✕</CloseButton>
            </LightboxContent>
          </LightboxCentered>
        )}
      </AnimatePresence>
    </LightboxDialog>
  );
}

const LightboxDialog = styled.dialog`
  padding: 0;
  border: none;
  background: transparent;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;

  &::backdrop {
    background: rgba(0, 0, 0, 0.85);
  }
`;

const LightboxCentered = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LightboxContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LightboxImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 0.8rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  top: -1.6rem;
  right: -1.6rem;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  border: none;
  background: white;
  color: #111;
  font-size: 1.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  transition: background 0.15s ease;

  &:hover {
    background: #f0f0f0;
  }
`;
